var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.03188 13.1954C10.4975 13.1954 13.3069 10.386 13.3069 6.92037C13.3069 3.45476 10.4975 0.645325 7.03188 0.645325C3.56627 0.645325 0.756836 3.45476 0.756836 6.92037C0.756836 10.386 3.56627 13.1954 7.03188 13.1954Z",
    stroke: "#BBBAB9",
    strokeWidth: 1.27434,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.01587 10.1358V5.9209",
    stroke: "#BBBAB9",
    strokeWidth: 1.27434,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04785 3.77789V3.70462",
    stroke: "#BBBAB9",
    strokeWidth: 1.27434,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipIcon);
export default __webpack_public_path__ + "static/media/tooltip-icon.e72af6de6304f8cbb93f2c5c281fee8e.svg";
export { ForwardRef as ReactComponent };